import { useEffect, useState } from 'react';

import { handleSearch, searchFieldExtractors } from '../../../utils/search';
import useSortableData from '../../../hooks/useSortableData';
import { useProviderDetailsState } from './useProviderDetailsState';

import type { IProviderAssignment } from '../../../../utils/types';

export function useProviderAssignedClientsSection() {
  const { clientAssignments, clientAssignmentsLoading } = useProviderDetailsState();
  const [assignedClients, setAssignedClients] = useState<IProviderAssignment[]>([]);
  const [clientSearchStr, setClientSearchStr] = useState('');

  const {
    data: sortedClientAssignments,
    handleSorting: sortClientAssignments,
    sortField: clientAssignmentsSortField,
    sortOrder: clientAssignmentsSortOrder,
  } = useSortableData(assignedClients, 'date_start', 'desc');

  useEffect(() => {
    setAssignedClients(clientAssignments);
  }, [clientAssignments]);

  const handleClientSearch = (searchStr: string) => {
    handleSearch(
      searchStr,
      clientAssignments,
      (assignment) => [
        ...searchFieldExtractors.nameFields(assignment?.client),
        assignment?.clinical_relationship,
      ],
      setClientSearchStr,
      setAssignedClients,
    );
  };

  return {
    sortedClientAssignments,
    clientAssignmentsLoading,
    clientSearchStr,
    clientAssignmentsSortField,
    clientAssignmentsSortOrder,
    handleClientSearch,
    sortClientAssignments,
  };
}
